<template>
    <div class="secure-sign__container">
        <v-container>
            <s-s-form-header
                title="Denzapine Monitoring Service Patient Bulk Transfer Form (Brand to Denzapine) Approval Form"
                document-number=""
                version=""
                effective-date=""
                review-date=""
                supersedes=""
            ></s-s-form-header>
            <v-col cols="12">
                <h1 class="text-center">
                    Denzapine Monitoring Service Patient Bulk Transfer Form (Brand to Denzapine) Approval Form
                </h1>
                <h4 class="text-center mb-8">
                    Please complete all form fields before submission of application. Missing information may result in
                    delays to patient transfer. To be used in conjunction with Patient Bulk Transfer Form (Brand to
                    Denzapine) - Patient and Pharmacy Details (PV01F48)
                </h4>
                <v-form ref="form" v-model="isFormValid" :disabled="isDisabled">
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Number of patients transferring to Denzapine from</h5>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.clozaril"
                                :rules="validationRules.clozaril"
                                label="Clozaril:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.zaponex"
                                :rules="validationRules.zaponex"
                                label="Zaponex:"
                                mandatory
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Number of patients one</h5>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.tablets"
                                :rules="validationRules.tablets"
                                label="Tablets:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.suspension"
                                :rules="validationRules.suspension"
                                label="Suspension:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12">
                            <p>
                                The transferring patients have been advised that their data will be transferred to an
                                alternative clozapine supplier Note: This is required as per data protection requirement
                                not patient consent only. If details not provided this may prevent the transfer taking
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Transferring to:</h5>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.nameOfPrescriber"
                                :rules="validationRules.nameOfPrescriber"
                                label="Name of Prescriber:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-date-picker-store
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.proposedDateOfTransfer"
                                label="Proposed date of transfer:"
                                :rules="validationRules.proposedDateOfTransfer"
                                mandatory
                            ></b-date-picker-store>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Additional Information:</h5>
                        </v-col>
                        <v-col cols="12" sm="12" class="py-0">
                            <b-textarea
                                auto-grow
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.additionalInformation"
                                label=""
                                :rules="validationRules.additionalInformation"
                                mandatory
                            ></b-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Consultant Psychiatrist:</h5>
                        </v-col>
                        <v-col cols="12">
                            <p>
                                I confirm that the patient has been informed that (and has agreed to) his / her data
                                being held on file (whether in electronic or hard copy form). The patient is aware that
                                the data may be used to make decisions about their treatment.
                            </p>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.consultantName"
                                :rules="validationRules.consultantName"
                                label="Name (please print):"
                                mandatory
                            ></b-input>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <h5 class="patient-form-title mt-5">Signature</h5>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <b-date-picker-store
                                hide-details
                                to-mutate="secure_sign_forms::patientBulkTransferFormBrandToDenzapineApprovalForm.date"
                                label="Date"
                                :rules="validationRules.date"
                                mandatory
                            ></b-date-picker-store>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="8">
                            <secure-sign-form-signature-component
                                ref="signaturePad"
                                :form-type="form"
                                :is-disabled="isDisabled"
                            ></secure-sign-form-signature-component>
                        </v-col>
                        <v-col
                            v-if="!isDisabled"
                            cols="12"
                            sm="4"
                            class="d-flex flex-column justify-content-end align-items-center"
                        >
                            <secure-sign-form-recaptcha
                                ref="recaptcha"
                                :valid-recaptcha="validRecaptcha"
                                :is-disabled="isDisabled"
                                @expired="expired"
                                @verify="onRecaptchaVerify"
                            ></secure-sign-form-recaptcha>
                            <v-btn
                                :loading="loading"
                                class="mt-2"
                                max-width="304px"
                                width="100%"
                                size="x-large"
                                color="primary"
                                :disabled="isDisabled"
                                @click="submit"
                                >Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                    <s-s-form-footer>
                        <p>
                            Should you have any queries, please do not hesitate to contact the Denzapine Monitoring
                            Service Team on 0333 200 4141
                        </p>
                        <p>Job Code: Date of prep:</p>
                    </s-s-form-footer>
                </v-form>
            </v-col>
        </v-container>
    </div>
</template>

<script>
import SSFormHeader from './partials/SSFormHeader.vue';
import SSFormFooter from './partials/SSFormFooter.vue';

let formControl = require('./mixins/FormControl.js').default;
export default {
    components: { SSFormFooter, SSFormHeader },
    mixins: [formControl],
    data() {
        return {
            validationRules: {
                clozaril: [(v) => !!v || t('users::validation.field.required')],
                zaponex: [(v) => !!v || t('users::validation.field.required')],
                tablets: [(v) => !!v || t('users::validation.field.required')],
                suspension: [(v) => !!v || t('users::validation.field.required')],
                nameOfPrescriber: [(v) => !!v || t('users::validation.field.required')],
                proposedDateOfTransfer: [(v) => !!v || t('users::validation.field.required')],
                additionalInformation: [(v) => !!v || t('users::validation.field.required')],
                consultantName: [(v) => !!v || t('users::validation.field.required')],
                date: [(v) => !!v || t('users::validation.field.required')],
            },
            isFormValid: false,
            formType: 'patient-bulk-transfer-form-brand-to-denzapine-approval-form',
            form: 'patientBulkTransferFormBrandToDenzapineApprovalForm',
        };
    },
    created() {
        this.getFormData();
    },
    methods: {},
};
</script>

<style scoped></style>
